import React from 'react';
import * as messages from '@radnuc/messages';
import { withTranslation } from 'react-i18next';
import './ExpertSettingsDisplay.css'

import Config, {setConfig} from './Config';
import UserInvestigationDisplay from './UserInvestigationDisplay'
import DoseRateAlarmThresholdDisplay from './DoseRateAlarmThresholdDisplay'
import { AcknowledgeAlertInterface } from './StatusComponents';
import { InvestigationInterface } from './InvestigationDisplay';
import { AuthenticationInterface } from './AuthenticationDisplay';
import { UserInvestigationInfo } from './UserInvestigationDisplay'
import { LaneDisplayInterface } from './PrimaryDisplay'
import { t } from 'i18next';
import './i18n';
import i18n from './i18n';

export interface ExpertSettingsDisplayInterface { open: () => void, close: () => void }
export interface ExpertSettingsButtonProps {
    acknowledgeAlert?: boolean,
    acknowlegeAlertInterface?: AcknowledgeAlertInterface,
    investigationInterface?: InvestigationInterface,
    authenticationInterface?: AuthenticationInterface,
    userInvestigationInfo?: UserInvestigationInfo,
    laneDisplayInterface?: LaneDisplayInterface,
    defaultDoseRateAlarmThresh?: number,
    config: Config,
    isPrimary?: boolean,
    isCommercial?: boolean,
    hideDoseRateAlarmSettings?: boolean,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    showPCSLRTSettings?: boolean,
    uiVersionString?: string,
}
export interface ExpertSettingsButtonState { menuOpen: boolean }

export class ExpertSettingsButton extends React.Component<ExpertSettingsButtonProps, ExpertSettingsButtonState> {
    constructor(props: ExpertSettingsButtonProps) {
        super(props)
        this.state = {
            menuOpen: false
        }
    }

    handleButtonClick(flag: boolean) {
        this.setState(() => ({
            menuOpen: flag
        }));
    }

    render() {
        const expertSettingsDisplayInterface = {
            open: () => this.setState({ menuOpen: true }),
            close: () => this.setState({ menuOpen: false })
        }

        return (
            <>
                <div className={"metric-container"} style={{ cursor: 'pointer' }}
                        onClick={() => { this.handleButtonClick(true) }}>
                    <label className={"metric-title"}>Expert Settings</label>
                </div>
                <ExpertSettingsDisplay menuOpen={this.state.menuOpen} config={this.props.config}
                    alertAcknowledge={this.props.acknowledgeAlert} acknowledgeAlertInterface={this.props.acknowlegeAlertInterface}
                    investigationInterface={this.props.investigationInterface}
                    authenticationInterface={this.props.authenticationInterface}
                    userInvestigationInfo={this.props.userInvestigationInfo}
                    laneDisplayInterface={this.props.laneDisplayInterface}
                    defaultDoseRateAlarmThresh={this.props.defaultDoseRateAlarmThresh}
                    expertSettingsDisplayInterface={expertSettingsDisplayInterface}
                    isPrimary={this.props.isPrimary}
                    isCommercial={this.props.isCommercial}
                    hideDoseRateAlarmSettings={this.props.hideDoseRateAlarmSettings}
                    suppressedAlertsInterface={this.props.suppressedAlertsInterface}
                    showPCSLRTSettings={this.props.showPCSLRTSettings}
                    uiVersionString={this.props.uiVersionString}/>
            </>
        )
    }
}
export default ExpertSettingsButton

//Menu Mechanism
export interface SettingsComponentDisplayProps { title: string, content: any}
export interface SettingsComponentDisplayState { expanded: boolean }
export class SettingsComponentDisplay extends React.Component<SettingsComponentDisplayProps, SettingsComponentDisplayState> {
    panel_element: React.RefObject<HTMLDivElement>;
    accordion_element: React.RefObject<HTMLButtonElement>;

    constructor(props: SettingsComponentDisplayProps) {
        super(props)

        this.state = {
            expanded: false,
        }

        this.panel_element = React.createRef<HTMLDivElement>();
        this.accordion_element = React.createRef<HTMLButtonElement>();
        this.handleAccordionClick = this.handleAccordionClick.bind(this);
    }

    handleAccordionClick() {
        if (this.accordion_element.current !== null) {
            this.accordion_element.current.classList.toggle("active");
        }
        if (this.panel_element.current !== null) {
            var panel = this.panel_element.current;
            panel.classList.toggle("active");
            if (panel !== null) {
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = "";
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }
    }

    render() {
        var containerHeight: string;
        if (this.state.expanded) {
            containerHeight = "100%";
        } else {
            containerHeight = "1.2em";
        }
        return (
            <>
                <button className="accordion" onClick={this.handleAccordionClick} ref={this.accordion_element}>
                    <div id="status-summary" className="status-metric-container" style={{ height: containerHeight }}>
                        <label className="status-metric-title-big">
                            {t(this.props.title,{ns:'trans'})}
                        </label>
                    </div>
                </button>
                <div className="panel" ref={this.panel_element}>
                    {this.props.content}
                </div>
            </>
        )
    }
} withTranslation()
/*
<Translation ns="trans">
    {(t) => t(this.props.title)}
</Translation>
*/
//******************************************************************************
//Expert Setting components
//Gamma Sensitivity
export interface GammaSensitivitySettingProps {
    config?: messages.ConfigurationState.PCSConfig
    authenticationInterface?: AuthenticationInterface
}

export interface GammaSensitivitySettingState {
    goalConfig?: messages.ConfigurationState.PCSConfig
}

export class GammaSensitivitySetting extends React.Component<GammaSensitivitySettingProps, GammaSensitivitySettingState> {
    async setGammaSensitivitySetting(selection: number) {
        console.log('Set gamma sensitivity: ' + selection);

        let config = new messages.ConfigurationState.PCSConfig();
        config.sensitivity = selection;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.PCS;
        message.pcs = config;

        await setConfig(message);
    }

    handleSelection(selection: number) {
        if(!(this.props.config?.sensitivity === selection)){
            if(this.props.authenticationInterface)
                this.props.authenticationInterface.authenticate(()=>this.setGammaSensitivitySetting(selection));
            else
                this.setGammaSensitivitySetting(selection);
        }
    }

    render() {
        let gammaStandardClass;
        let gammaHighClass;
        if (this.props.config?.sensitivity === messages.ConfigurationState.PCSSensitivitySetting.STANDARD) {
            gammaStandardClass = 'selected';
        } else if (this.props.config?.sensitivity === messages.ConfigurationState.PCSSensitivitySetting.HIGH) {
            gammaHighClass = 'selected';
        }

        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Gamma Sensitivity</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-sensitivity-standard" className={"round-skinny-button " + gammaStandardClass}
                        onClick={() => this.handleSelection(messages.ConfigurationState.PCSSensitivitySetting.STANDARD)}>Standard</div>
                    <div id="expert-menu-sensitivity-high" className={"round-skinny-button " + gammaHighClass}
                        onClick={() => this.handleSelection(messages.ConfigurationState.PCSSensitivitySetting.HIGH)}>High</div>
                </div>
            </div>
        )
    }
}


//Neutron Sensitivity
export interface NeutronSensitivitySettingProps {
    config?: messages.ConfigurationState.NeutronConfig
    authenticationInterface?: AuthenticationInterface
}

export interface NeutronSensitivitySettingState {
    goalConfig?: messages.ConfigurationState.NeutronConfig
}

export class NeutronSensitivitySetting extends React.Component<NeutronSensitivitySettingProps, NeutronSensitivitySettingState> {
    async setNeutronSensitivitySetting(selection: number) {
        console.log('Set neutron sensitivity cfar: ' + selection);

        let config = new messages.ConfigurationState.NeutronConfig();
        config.mode = messages.ConfigurationState.NeutronMode.LRT_FILTER;
        config.cfar_hours = selection;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.NEUTRON;
        message.neutron = config;

        await setConfig(message);
    }

    handleSelection(selection: number) {
        if(!(this.props.config?.cfar_hours === selection)){
            if(this.props.authenticationInterface)
                this.props.authenticationInterface.authenticate(()=>this.setNeutronSensitivitySetting(selection));
                else
                    this.setNeutronSensitivitySetting(selection);
        }
    }

    render() {
        let neutronCFAR3Class;
        let neutronCFAR12Class;
        let neutronCFAR48Class;
        let neutronCFAR340Class;
        if (this.props.config?.cfar_hours === 3) {
            neutronCFAR3Class = 'selected';
        } else if (this.props.config?.cfar_hours === 12) {
            neutronCFAR12Class = 'selected';
        } else if (this.props.config?.cfar_hours === 48) {
            neutronCFAR48Class = 'selected';
        } else if (this.props.config?.cfar_hours === 340) {
            neutronCFAR340Class = 'selected';
        }

        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title" style={{whiteSpace:'normal'}}>Neutron Sensitivity</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-sensitivity-cfar3" className={"round-skinny-button " + neutronCFAR3Class}
                        onClick={() => this.handleSelection(3)}>High</div>
                    <div id="expert-menu-sensitivity-cfar12" className={"round-skinny-button " + neutronCFAR12Class}
                        onClick={() => this.handleSelection(12)}>CFAR 12Hr</div>
                    <div id="expert-menu-sensitivity-cfar48" className={"round-skinny-button " + neutronCFAR48Class}
                        onClick={() => this.handleSelection(48)}>CFAR 48Hr</div>
                    <div id="expert-menu-sensitivity-cfar340" className={"round-skinny-button " + neutronCFAR340Class}
                        onClick={() => this.handleSelection(340)}>CFAR 340Hr</div>
                </div>
            </div>
        )
    }
}

//Neutron Background Reset
export interface NeutronBackgroundResetSettingProps {
    config?: messages.ConfigurationState.NeutronConfig
    authenticationInterface?: AuthenticationInterface
}

export interface NeutronBackgroundResetSettingState {
    goalConfig?: messages.ConfigurationState.NeutronConfig
}

export class NeutronBackgroundResetSetting extends React.Component<NeutronBackgroundResetSettingProps, NeutronBackgroundResetSettingState> {
    async resetNeutronBackgroundSetting() {
        console.log('Reset neutron background');

        let config = new messages.ConfigurationState.NeutronConfig();
        config.reset = true;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.NEUTRON;
        message.neutron = config;

        await setConfig(message);
    }

    handleSelection() {
        if(this.props.authenticationInterface)
            this.props.authenticationInterface.authenticate(()=>this.resetNeutronBackgroundSetting());
        else
            this.resetNeutronBackgroundSetting();
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title" style={{whiteSpace:'normal'}}>
                    {t('Reset Neutron Background',{ns:'trans'})}
                </label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-reset-neutron" className={"round-skinny-button "}
                        onClick={() => this.handleSelection()}>
                            {t('Reset',{ns:'trans'})}
                        </div>
                </div>
            </div>
        )
    }
}withTranslation()

//PCS LRT
export interface PCSLRTSettingProps {
    config?: messages.ConfigurationState.PCSConfig
    authenticationInterface?: AuthenticationInterface
}

export interface PCSLRTSettingState {
    goalConfig?: messages.ConfigurationState.PCSConfig
}

export class PCSLRTSetting extends React.Component<PCSLRTSettingProps, PCSLRTSettingState> {
    async setPCSLRTSetting(flag: boolean) {
        console.log('Set PCS-LRT flag: ' + flag);

        let config = new messages.ConfigurationState.PCSConfig();
        //TODO SET PCS-LRT MESSAGE FLAG
        config.lrt_enabled = flag;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.PCS;
        message.pcs = config;

        await setConfig(message);
    }

    handleSelection(flag: boolean) {

        //TODO SET PCS-LRT MESSAGE FLAG
        if(!(this.props.config?.lrt_enabled === flag)){
            if(this.props.authenticationInterface)
                this.props.authenticationInterface.authenticate(()=>this.setPCSLRTSetting(flag));
            else
                this.setPCSLRTSetting(flag);
        }

    }

    render() {
        let PCSLRTOnClass;
        let PCSLRTOffClass;
        if (this.props.config?.lrt_enabled === true) {
            PCSLRTOnClass = 'selected';
        } else if (this.props.config?.lrt_enabled === false) {
            PCSLRTOffClass = 'selected';
        }

        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">PCS-LRT</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-sensitivity-standard" className={"round-skinny-button " + PCSLRTOnClass}
                        onClick={() => this.handleSelection(true)}>{t('On',{ns:'trans'})}</div>
                    <div id="expert-menu-sensitivity-high" className={"round-skinny-button " + PCSLRTOffClass}
                        onClick={() => this.handleSelection(false)}>{t('Off',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()


//Sigma Reporting
export interface SigmaReportingSettingProps {
    config?: messages.ConfigurationState.SigmaEdgeConfig,
    authenticationInterface?: AuthenticationInterface
}

export interface SigmaReportingSettingState {
    goalConfig?: messages.ConfigurationState.SigmaEdgeConfig
}

export class SigmaReportingSetting extends React.Component<SigmaReportingSettingProps, SigmaReportingSettingState> {
    async setSigmaReportSetting(selection: boolean) {
        console.log('Set sigma reporting: ' + selection);
        var config = new messages.ConfigurationState.SigmaEdgeConfig();
        config.reporting = selection;

        this.setState({ goalConfig: config })

        let message = new messages.ConfigurationState.ConfigMessage();
        message.messageType = messages.ConfigurationState.ConfigMessageType.SET_COMMAND
        message.component = messages.ConfigurationState.ConfigComponent.SIGMA_EDGE;
        message.sigmaEdge = config;

        await setConfig(message);
    }

    handleSelection(selection: boolean) {
        if(!(this.props.config?.reporting === selection)){
            if(this.props.authenticationInterface)
                this.props.authenticationInterface.authenticate(()=>this.setSigmaReportSetting(selection));
            else
                this.setSigmaReportSetting(selection);
        }
    }

    render() {
        let sigmaReportingOnClass;
        let sigmaReportingOffClass;
        if (this.props.config?.reporting === true) {
            sigmaReportingOnClass = 'selected';
        } else if (this.props.config?.reporting === false) {
            sigmaReportingOffClass = 'selected';
        }

        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Sigma Reporting</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-sensitivity-standard" className={"round-skinny-button " + sigmaReportingOnClass}
                        onClick={() => this.handleSelection(true)}>On</div>
                    <div id="expert-menu-sensitivity-high" className={"round-skinny-button " + sigmaReportingOffClass}
                        onClick={() => this.handleSelection(false)}>Off</div>
                </div>
            </div>
        )
    }
}

//All Alerts Expand/Collapse
export interface AllAlertsCollapseSettingProps {}
export class AllAlertsCollapseSetting extends React.Component<AllAlertsCollapseSettingProps> {
    handleSelection(selection: boolean) {
        //console.log('All alerts Collapse: ' + selection);
        var buttons = document.getElementsByClassName('inv-exp-collapse-container');
        if (buttons !== null) {
            if (buttons.length > 0) {
                for (var i = 0; i < buttons.length; i++) {
                    var button = buttons?.item(i) as HTMLDivElement;
                    if (selection) {
                        //Expand all
                        if (button.innerText === '\u2212') {
                            button.click();
                        }
                    } else {
                        //Collapse all
                        if (button.innerText === '\u002B') {
                            button.click();
                        }
                    }
                };
            }
        }
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('All Alerts',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-sensitivity-high" className={"round-skinny-button"}
                        onClick={() => this.handleSelection(true)}>{t('Collapse',{ns:'trans'})}</div>
                    <div id="expert-menu-sensitivity-standard" className={"round-skinny-button"}
                        onClick={() => this.handleSelection(false)}>{t('Expand',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()

//Export All Alerts
export interface AllAlertsExportSettingProps {}
export interface AllAlertsExportSettingState { buttonClass: string }
export class AllAlertsExportSetting extends React.Component<AllAlertsExportSettingProps, AllAlertsExportSettingState> {
    timeoutTimer: NodeJS.Timeout | null = null;
    constructor(props: AllAlertsExportSettingProps) {
        super(props)
        this.state = {
            buttonClass: ''
        }
        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        if (this.state.buttonClass.match('warn')) {
            //Export confirmed
            //console.log('All alerts export');
            this.setState({ buttonClass: 'confirm' });
            this.startTimer(1000);
            var buttons = document.getElementsByClassName('inv-export-all-hidden');
            if (buttons !== null) {
                if (buttons.length > 0) {
                    var delayIndex = 0;
                    for (var i = 0; i < buttons.length; i++) {
                        const thisDelay = 1000 * delayIndex;
                        const button = buttons?.item(i) as HTMLDivElement;
                        setTimeout(() => {
                            //Export if it still exists
                            if (button.isConnected)
                                button.click();
                        }, thisDelay);
                        delayIndex++;
                    };
                }
            }
        } else {
            //Arm
            this.setState({ buttonClass: 'warn' });
            this.startTimer(5000);
        }
    }

    startTimer(duration: number) {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        this.timeoutTimer = setTimeout(() => {
            //Change in state triggers redraw
            this.setState({ buttonClass: '' });
        }, duration)
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('Export All Alerts',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-alert-export-all" className={"round-skinny-button " + this.state.buttonClass}
                        onClick={() => this.handleSelection()}>{t('Export',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()

//Dismiss All Alerts
export interface AllAlertsDismissSettingProps { investigationInterface?: InvestigationInterface}
export interface AllAlertsDismissSettingState { buttonClass: string }
export class AllAlertsDismissSetting extends React.Component<AllAlertsDismissSettingProps, AllAlertsDismissSettingState> {
    timeoutTimer: NodeJS.Timeout | null = null;
    constructor(props: AllAlertsDismissSettingProps) {
        super(props)
        this.state = {
            buttonClass: ''
        }
        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        if (this.state.buttonClass.match('warn')) {
            //Dismiss confirmed
            //console.log('All alerts Dismiss');
            this.setState({ buttonClass: 'confirm' });
            this.startTimer(1000);

            if(this.props.investigationInterface !== undefined && this.props.investigationInterface.dismissAll !== undefined){
                //Dismiss via investigation Interface
                console.log('Dismiss via investigationInterface');
                this.props.investigationInterface.dismissAll();

            } else {
                //Dismiss via simulated button push if investigationInterface is not defined
                var buttons = document.getElementsByClassName('inv-delete-all-hidden');
                if (buttons !== null) {
                    if (buttons.length > 0) {
                        for (var i = 0; i < buttons.length; i++) {
                            const button = buttons?.item(i) as HTMLDivElement;
                            //Dismiss all
                            button.click();
                        };
                    }
                }
            }
        } else {
            //Arm
            this.setState({ buttonClass: 'warn' });
            this.startTimer(5000);
        }
    }

    startTimer(duration: number) {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        this.timeoutTimer = setTimeout(() => {
            //Change in state triggers redraw
            this.setState({ buttonClass: '' });
        }, duration)
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('Dismiss All Alerts',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="expert-menu-alert-clear-all" className={"round-skinny-button " + this.state.buttonClass}
                        onClick={() => this.handleSelection()}>{t('Dismiss',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()

//Day Map Type
export interface MapDayTypeSettingProps { }
export interface MapDayTypeSettingState { }
export class MapDayTypeSetting extends React.Component<MapDayTypeSettingProps, MapDayTypeSettingState> {
    constructor(props: MapDayTypeSettingProps) {
        super(props)

        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection(selection: boolean) {
        var buttons
        if (selection) {
            buttons = document.getElementsByClassName('map-select-day-map-simple-hidden');
        } else {
            buttons = document.getElementsByClassName('map-select-day-map-detailed-hidden');
        }
        if (buttons !== null) {
            if (buttons.length > 0) {
                const button = buttons?.item(0) as HTMLDivElement;
                button.click();
                this.setState({ isSimple: selection })
            }
        }
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Map Server (Day)</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="map-tile-detailed" className={"round-skinny-button "}
                        onClick={() => this.handleSelection(false)}>Detailed</div>
                    <div id="map-tile-simple" className={"round-skinny-button "}
                        onClick={() => this.handleSelection(true)}>Simple</div>
                </div>
            </div>
        )
    }
}

//Map Trail Clear
export interface MapClearTrailSettingProps { }
export interface MapClearTrailSettingState { }
export class MapClearTrailSetting extends React.Component<MapDayTypeSettingProps, MapDayTypeSettingState> {
    constructor(props: MapClearTrailSettingProps) {
        super(props)

        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        var buttons = document.getElementsByClassName('map-clear-trail-hidden');
        if (buttons !== null) {
            if (buttons.length > 0) {
                const button = buttons?.item(0) as HTMLDivElement;
                button.click();
            }
        }
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Clear Trail</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="map-tile-detailed" className={"round-skinny-button"}
                        onClick={() => this.handleSelection()}>Clear</div>
                </div>
            </div>
        )
    }
}

//Alert Acknowledge On/Off
export interface AlertAcknowledgeSettingProps {
    alertAcknowledge: boolean,
    acknowledgeAlertInterface: AcknowledgeAlertInterface,
    authenticationInterface?: AuthenticationInterface}
export class AlertAcknowledgeSetting extends React.Component<AlertAcknowledgeSettingProps> {

    render() {
        let alertAcknowledgeOnClass;
        let alertAcknowledgeOffClass
        if (this.props.alertAcknowledge === true) {
            alertAcknowledgeOnClass = 'selected';
        } else if (this.props.alertAcknowledge === false) {
            alertAcknowledgeOffClass = 'selected';
        }

        const onClickSetAlertAcknowledge = (flag:boolean) => {
            if(this.props.alertAcknowledge !== flag){
                if(this.props.authenticationInterface){
                    this.props.authenticationInterface.authenticate(()=>this.props.acknowledgeAlertInterface.setAlertAcknowledge(flag));
                } else {
                    this.props.acknowledgeAlertInterface.setAlertAcknowledge(flag);
                }
            }
        }
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Alert Acknowledge</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className={"round-skinny-button "+alertAcknowledgeOnClass}
                        onClick={() => onClickSetAlertAcknowledge(true)}>On</div>
                    <div className={"round-skinny-button "+alertAcknowledgeOffClass}
                        onClick={() => onClickSetAlertAcknowledge(false)}>Off</div>
                </div>
            </div>
        )
        /*
        onClick={() => this.props.acknowledgeAlertInterface.setAlertAcknowledge(true)}>On</div>
        */
    }
}
//******************************************************************************
//use Dose Rate SI Unit On/Off
export interface UIDisplaySettingInterface {
    useDoseRateSIUnit: boolean,
    setDoseRateSIUnit: (flag: boolean) => void,
}
export interface DoseRateUnitSettingProps {
    uiDisplaySettingInterface?: UIDisplaySettingInterface
}
export class DoseRateUnitSetting extends React.Component<DoseRateUnitSettingProps> {

    render() {
        if( this.props.uiDisplaySettingInterface !== undefined) {
            let useDoseSIUnitOnClass;
            let useDoseSIUnitOffClass
            if (this.props.uiDisplaySettingInterface.useDoseRateSIUnit === true) {
                useDoseSIUnitOnClass = 'selected';
            } else if (this.props.uiDisplaySettingInterface.useDoseRateSIUnit === false) {
                useDoseSIUnitOffClass = 'selected';
            }

            const onClickSetDoseSIUnit = (flag:boolean) => {
                if(this.props.uiDisplaySettingInterface!.useDoseRateSIUnit !== flag){
                    this.props.uiDisplaySettingInterface!.setDoseRateSIUnit(flag);
                }
            }
            return (
                <div className="status-metric-container vertical-padding">
                    <label className="status-metric-title" style={{whiteSpace:'normal'}}>{t('Dose Rate Unit',{ns:'trans'})}</label>
                    <div style={{ display: 'flex', flexDirection: 'row'}}>
                        <div className={"round-skinny-button "+useDoseSIUnitOnClass} style={{whiteSpace:'nowrap'}}
                            onClick={() => onClickSetDoseSIUnit(true)}>{t('μSv/hr',{ns:'trans'})}</div>
                        <div className={"round-skinny-button "+useDoseSIUnitOffClass} style={{whiteSpace:'nowrap'}}
                            onClick={() => onClickSetDoseSIUnit(false)}>{t('μR/hr',{ns:'trans'})}</div>
                    </div>
                </div>
            )
        } else {
            return (<></>)
        }
    }
} withTranslation()
//******************************************************************************


//Change Password
export interface ChangePasswordSettingProps { authenticationInterface?: AuthenticationInterface}
export interface ChangePasswordSettingState { }
export class ChangePasswordSetting extends React.Component<ChangePasswordSettingProps, ChangePasswordSettingState> {
    constructor(props: ChangePasswordSettingProps) {
        super(props)

        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        //TODO launch change password
        if(this.props.authenticationInterface !== undefined)
            this.props.authenticationInterface.change_password();
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('Change Password',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="change-password" className={"round-skinny-button"}
                        onClick={() => this.handleSelection()}>{t('Change',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()


//******************************************************************************
export interface PrimaryLaneToDisplaySettingProps {
    laneDisplayInterface?: LaneDisplayInterface
    authenticationInterface?: AuthenticationInterface
}
export class PrimaryLaneToDisplaySetting extends React.Component<PrimaryLaneToDisplaySettingProps> {
    laneNumbers: number[] = [];
    laneLabels: String[] = []
    num_lanes: number = 4;

    componentDidUpdate(prevProps: PrimaryLaneToDisplaySettingProps ){
        if(this.props.laneDisplayInterface !== prevProps.laneDisplayInterface)
            this.calculateNumLanesAndLabels();
    }

    calculateNumLanesAndLabels(){
        const num_lanes = this.props.laneDisplayInterface?.laneNumberAndLabel?.length || 4;
        this.laneNumbers = new Array(num_lanes);
        this.laneLabels = new Array(num_lanes);
        if(this.props.laneDisplayInterface?.laneNumberAndLabel){
            this.props.laneDisplayInterface?.laneNumberAndLabel.forEach((lane)=>{
                this.laneNumbers.push(lane.laneNumber);
                this.laneLabels.push(lane.laneLabel);
            });
        } else {
            //LaneNumberAndLabel Undefined
            for(let i=0;i<num_lanes;i++){
                this.laneNumbers.push(i);
                this.laneLabels.push((i+1).toFixed(0));
            }
        }
    }

    handleSelection(selection?: number) {
            if(this.props.authenticationInterface)
                this.props.authenticationInterface.authenticate(()=>this.setLaneToDisplaySetting(selection));
            else
                this.setLaneToDisplaySetting(selection);
    }

    setLaneToDisplaySetting(selection?: number){
        if(selection===undefined){
            this.props.laneDisplayInterface?.unselect();
        } else {
            this.props.laneDisplayInterface?.select(selection);
        }
    }

    render() {

        let laneClasses:String[] =  new Array(this.num_lanes);
        let laneAllClass;
        this.laneNumbers.forEach((num,idx)=>{
            if (this.props.laneDisplayInterface?.laneToDisplay === this.laneNumbers[idx]) {
                laneClasses[idx] = 'selected';
            }
        });
        if(this.props.laneDisplayInterface?.laneToDisplay === undefined){
            laneAllClass = 'selected';
        }

        let laneSelectButton:JSX.Element[] = [];
        this.laneNumbers.forEach((num,idx)=>{
            const this_button =
                <div key={idx} className={"round-skinny-button " + laneClasses[idx]}
                            onClick={() => this.handleSelection(this.laneNumbers[idx])}>{this.laneLabels[idx]}</div>
            laneSelectButton.push(this_button)
        });
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title" style={{whiteSpace:'nowrap'}}>Lane To Display</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {laneSelectButton}
                    <div className={"round-skinny-button " + laneAllClass}
                        onClick={() => this.handleSelection()}>All</div>
                </div>
            </div>
        )
    }
}
//******************************************************************************
//Refresh Page
export interface RefreshPageSettingProps {}
export interface RefreshPageSettingState { }
export class RefreshPageSetting extends React.Component<RefreshPageSettingProps, RefreshPageSettingState> {
    constructor(props: RefreshPageSettingProps) {
        super(props)

        this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection() {
        document.location.reload(true);
    }

    render() {
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('Refresh Page',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div id="refresh-page" className={"round-skinny-button"}
                        onClick={() => this.handleSelection()}>{t('Refresh',{ns:'trans'})}</div>
                </div>
            </div>
        )
    }
} withTranslation()

//******************************************************************************
//Select language
export interface SelectLanguageInterface { lang:string, select: (lang:string) => void}
export interface SelectLanguageSettingProps {selectLanguageInterface?:SelectLanguageInterface}
export class SelectLanguageSetting extends React.Component<SelectLanguageSettingProps> {
    constructor(props: SelectLanguageSettingProps) {
        super(props)
    }

    componentDidUpdate(prevProps: SelectLanguageSettingProps) {
        //This sets the language for the react-ui-components
        if(this.props.selectLanguageInterface !== undefined){
            if(i18n.language !== this.props.selectLanguageInterface.lang)
                i18n.changeLanguage(this.props.selectLanguageInterface.lang);
        }
    }

    render() {

        const languageList = ['en','cz','hu','ro','ru','sk']; //N.B Add all available languages
        const languageModes = languageList.map((mode) => {
            return(
                <option value={mode} key={mode}>{t(mode,{ns:'trans'})+' ('+mode+')'}</option>
            )
        })
        let current_language;
        if(this.props.selectLanguageInterface !== undefined){
            current_language = this.props.selectLanguageInterface.lang;
        } else {
            current_language = i18n.language;
        }
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">{t('Language',{ns:'trans'})}</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                <select className="modern-skinny" value={current_language}
                    onChange={(e) => {
                        i18n.changeLanguage(e.target.value);
                        if(this.props.selectLanguageInterface !== undefined){
                            this.props.selectLanguageInterface.select(e.target.value);
                        }
                    }}>
                    {languageModes}
                </select>
                </div>
            </div>
        )
    }
} withTranslation()

//******************************************************************************
//Suppressed Alerts settings
export interface SuppressedAlertsInterface {showSuppressedAlerts: boolean, setShowSuppressedAlerts: (flag:boolean)=> void,}
export interface SuppressedAlertsSettingProps {
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    authenticationInterface?: AuthenticationInterface}
export class SuppressedAlertsSetting extends React.Component<SuppressedAlertsSettingProps> {

    render() {
        let showSuppressedAlertOnClass;
        let showSuppressedAlertOffClass
        if (this.props.suppressedAlertsInterface?.showSuppressedAlerts === true) {
            showSuppressedAlertOnClass = 'selected';
        } else {//if (this.props.showSuppressedAlerts === false) {
            showSuppressedAlertOffClass = 'selected';
        }

        const onClickShowSuppressedAlertOnClass = (flag:boolean) => {
            if(this.props.suppressedAlertsInterface?.showSuppressedAlerts !== flag){
                if(this.props.authenticationInterface){
                    this.props.authenticationInterface.authenticate(()=>this.props.suppressedAlertsInterface?.setShowSuppressedAlerts(flag));
                } else {
                    this.props.suppressedAlertsInterface?.setShowSuppressedAlerts(flag);
                }
            }
        }
        return (
            <div className="status-metric-container vertical-padding">
                <label className="status-metric-title">Show Suppressed Alerts</label>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div className={"round-skinny-button "+showSuppressedAlertOnClass}
                        onClick={() => onClickShowSuppressedAlertOnClass(true)}>On</div>
                    <div className={"round-skinny-button "+showSuppressedAlertOffClass}
                        onClick={() => onClickShowSuppressedAlertOnClass(false)}>Off</div>
                </div>
            </div>
        )
    }
}

//******************************************************************************
//Expert Settings Menu
export interface ExpertSettingsDisplayProps {
    config: Config,
    menuOpen: boolean,
    alertAcknowledge?: boolean,
    acknowledgeAlertInterface?: AcknowledgeAlertInterface,
    investigationInterface?: InvestigationInterface,
    expertSettingsDisplayInterface: ExpertSettingsDisplayInterface,
    authenticationInterface?: AuthenticationInterface,
    userInvestigationInfo?: UserInvestigationInfo,
    laneDisplayInterface?: LaneDisplayInterface,
    defaultDoseRateAlarmThresh?: number,
    isPrimary?: boolean,
    isCommercial?: boolean,
    hideDoseRateAlarmSettings?: boolean,
    suppressedAlertsInterface?: SuppressedAlertsInterface,
    showPCSLRTSettings?: boolean,
    uiVersionString?: string,
}

export class ExpertSettingsDisplay extends React.Component<ExpertSettingsDisplayProps> {
    constructor(props: ExpertSettingsDisplayProps) {
        super(props)
        this.handleMenuCloseButtonClick = this.handleMenuCloseButtonClick.bind(this);

    }
    handleMenuCloseButtonClick() {
        this.props.expertSettingsDisplayInterface.close();
    }

    render() {
        var sidenavClassName = "sidenav";
        if (this.props.menuOpen) {
            sidenavClassName += " open"
        }
        const mapSettings =
            <div>
                <MapClearTrailSetting />
                <MapDayTypeSetting />
                <br></br>
            </div>

        let pcsLrtSetting;
        if(this.props.showPCSLRTSettings){
            pcsLrtSetting = <PCSLRTSetting config={this.props.config.pcs} authenticationInterface={this.props.authenticationInterface}/>
        }

        const detectionSettings =
            <div>
                <GammaSensitivitySetting config={this.props.config.pcs} authenticationInterface={this.props.authenticationInterface}/>
                <NeutronSensitivitySetting config={this.props.config.neutron} authenticationInterface={this.props.authenticationInterface}/>
                {pcsLrtSetting}
                <br></br>
            </div>


        let acknowledgeAlertSettings;
        if(this.props.alertAcknowledge !== undefined && this.props.acknowledgeAlertInterface !== undefined){
            acknowledgeAlertSettings =
                <AlertAcknowledgeSetting alertAcknowledge={this.props.alertAcknowledge} acknowledgeAlertInterface={this.props.acknowledgeAlertInterface}
                    authenticationInterface={this.props.authenticationInterface}/>
        }

        let userInvestigationSettings;
        if(this.props.isPrimary){
            userInvestigationSettings =
                <div className="status-metric-container vertical-padding">
                    <label className="status-metric-title">Manual Investigation</label>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <UserInvestigationDisplay userInvestigationInfo={this.props.userInvestigationInfo} style={{ width: '250px' }}/>
                    </div>
                </div>
        }

        let doseRateAlarmSettings;
        if(this.props.hideDoseRateAlarmSettings === undefined || this.props.hideDoseRateAlarmSettings === false){
            doseRateAlarmSettings =
                <div className="status-metric-container vertical-padding">
                <DoseRateAlarmThresholdDisplay config={this.props.config.inv} authenticationInterface={this.props.authenticationInterface}
                    defaultDoseRateAlarmThresh={this.props.defaultDoseRateAlarmThresh}/>
                </div>
        }

        let classNameSuppressedAlertsMenu = "suppressed-alerts-menu";
        if( this.props.suppressedAlertsInterface?.showSuppressedAlerts !== true ){
            classNameSuppressedAlertsMenu += " hidden";
        }
        const showSuppressedAlertsSettings =
                <div id={'suppressed-alerts-menu'} className={classNameSuppressedAlertsMenu}>
                    <SuppressedAlertsSetting suppressedAlertsInterface={this.props.suppressedAlertsInterface} authenticationInterface={this.props.authenticationInterface}/>
                </div>

        const alertsSettings =
            <div>
                <SigmaReportingSetting config={this.props.config.reporting} authenticationInterface={this.props.authenticationInterface}/>
                <AllAlertsCollapseSetting />
                <AllAlertsExportSetting />
                <AllAlertsDismissSetting investigationInterface={this.props.investigationInterface}/>
                {acknowledgeAlertSettings}
                {userInvestigationSettings}
                {doseRateAlarmSettings}
                {showSuppressedAlertsSettings}
                <br></br>
            </div>

        let primaryLaneToDisplaySettings;
        if(this.props.isPrimary){
            primaryLaneToDisplaySettings=<PrimaryLaneToDisplaySetting laneDisplayInterface={this.props.laneDisplayInterface} authenticationInterface={this.props.authenticationInterface}/>
        }


        let changePasswordSettings;
        if(this.props.acknowledgeAlertInterface !== undefined){
            changePasswordSettings = <ChangePasswordSetting authenticationInterface={this.props.authenticationInterface}/>
        }
        let uiVersionDisplay;
        if(this.props.uiVersionString !== undefined){
            const uiVersionString = "UI Version: "+this.props.uiVersionString;
            uiVersionDisplay =
                <label className="status-metric-title" style={{whiteSpace:'nowrap',padding:'10px',fontSize:'0.8em'}}>
                    {uiVersionString}
                </label>
        }
        const managementSettings =
            <div>
                {changePasswordSettings}
                {primaryLaneToDisplaySettings}
                <RefreshPageSetting/>
                <br></br><br></br>
                {uiVersionDisplay}
            </div>


        const settingsContainer =
            <div id="expert-settings-container" className={sidenavClassName}>
                <div className="sidenav-menu" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="status-metric-container">
                        <label className="status-metric-title-big">Expert Settings</label>
                    </div>
                    <div className="closebtn" style={{ cursor: 'pointer' }} onClick={this.handleMenuCloseButtonClick}>&times;</div>
                </div>
                <div className="sidenav-container">
                    <SettingsComponentDisplay title={"Detection"} content={detectionSettings} />
                    <SettingsComponentDisplay title={"Alerts"} content={alertsSettings} />
                    <SettingsComponentDisplay title={"Management"} content={managementSettings} />
                </div>
            </div>

        return (
            <>
                {settingsContainer}
            </>
        )
    }
}
